<template>
  <div class="div-table">
    <div class="columns is-gapless">
      <div class="column is-12 card-header has-text-centered">
        <strong class="is-size-7-touch">My Tournaments</strong>
      </div>
    </div>
    <div class="columns is-gapless">
      <div class="column is-6" />
      <!--<div class="column is-6 has-text-centered">-->
      <!--<div class="dropdown is-fullwidth" @click="showFilter()" :class="{'is-active': dropdownFilter}">-->
      <!--<div class="dropdown-trigger is-fullwidth">-->
      <!--<button class="button is-fullwidth is-small" aria-haspopup="true" aria-controls="dropdown-menu">-->
      <!--<span>Filter</span>-->
      <!--<span class="icon is-small">-->
      <!--<i class="far fa-angle-down" aria-hidden="true"></i>-->
      <!--</span>-->
      <!--</button>-->
      <!--</div>-->
      <!--<div class="dropdown-menu is-fullwidth" id="dropdown-menu" role="menu">-->
      <!--<div class="dropdown-content">-->
      <!--<a class="navbar-item" @click="switchHistory('year')">This Year</a>-->
      <!--<a class="navbar-item" @click="switchHistory('lastMonth')">Last Month</a>-->
      <!--<a class="navbar-item" @click="switchHistory('thisMonth')">This Month</a>-->
      <!--</div>-->
      <!--</div>-->
      <!--</div>-->
      <!--</div>-->
      <div
        class="column is-6"
        style="position:relative"
      >
        <vue-monthly-picker
          v-model="selectedDate"
          class="select is-small"
          style="margin-top:-9px"
          :format="'MMMM yyyy'"
          :minimum-view="'month'"
          :maximum-view="'month'"
        />
      </div>
    </div>
    <div class="columns is-gapless is-flex">
      <div
        class="column is-3 has-text-centered"
        style="order: 1;"
      >
        <strong class="is-size-7">Date</strong>
      </div>
      <div
        class="column is-3 has-text-centered"
        style="order: 2;"
      >
        <strong class="is-size-7">Venue</strong>
      </div>
      <div
        class="column is-2 has-text-centered"
        style="order: 3;"
      >
        <strong class="is-size-7">Place</strong>
      </div>
      <div
        class="column is-2 has-text-centered"
        style="order: 4;"
      >
        <strong class="is-size-7">Points</strong>
      </div>
      <div
        class="column is-2 has-text-centered"
        style="order: 5;"
      >
        <strong class="is-size-7">Ent.</strong>
      </div>
    </div>
    <div
      v-for="game in paginatedTournaments"
      v-if="paginatedTournaments"
      class="columns is-gapless is-flex"
    >
      <div
        class="column is-3 has-text-centered"
        style="order: 1;"
      >
        <router-link
          class="is-size-7"
          :to="{path: `/tournaments/${game.tournid}`}"
        >
          {{ game.date }}
        </router-link>
      </div>

      <div
        class="column is-3 has-text-centered-touch"
        style="order: 2; overflow-x: hidden;"
      >
        <router-link :to="{name: 'VenueDetails', params: {id: game.venue}}">
          <strong class="is-size-7">{{ game.name }}</strong>
        </router-link>
      </div>

      <div
        class="column is-2 has-text-centered"
        style="order: 3;"
      >
        <span class="is-size-7">{{ game.place }}</span>
      </div>

      <div
        class="column is-2 has-text-centered"
        style="order: 4;"
      >
        <span class="is-size-7">{{ game.points }}</span>
      </div>

      <div
        class="column is-2 has-text-centered"
        style="order: 5;"
      >
        <span class="is-size-7">{{ game.entrants }}</span>
      </div>
    </div>
    <pagination
      :pagination="pagination"
      per-page="10"
      :total="tournaments.length"
      @paginateMinus="paginateMinus"
      @paginatePlus="paginatePlus"
    />
    <div
      v-if="!paginatedTournaments"
      class="column is-12 has-text-centered"
    >
      <span>There are no any results for this period</span>
    </div>
  </div>
</template>

<script>
  import VueMonthlyPicker from '../helpers/Datepicker.vue'
  import Pagination from '../helpers/Pagination.vue'
  import axios from 'axios'
  export default {
    components: {
      VueMonthlyPicker,
      Pagination
    },
    props: ['player', 'user', 'token'],
    data () {
      return {
        dropdownYear: false,
        dropdownMonth: false,
        dropdownVenue: false,
        dropdownFilter: false,
        history: 'year',
        selectedYear: '',
        selectedMonth: '',
        selectedDate: new Date(),
        tournaments: [],
        loaded: false,
        pagination: 0
      }
    },
    computed: {
      paginatedTournaments () {
        return this.tournaments.slice(this.pagination, (this.pagination + 10))
      }
    },
    watch: {
      selectedDate (val) {
        let date = new Date(val)
        this.selectedMonth = date.getMonth()
        this.selectedYear = date.getFullYear()
        this.getTournaments()
      }
    },
    mounted () {
      this.selectedYear = this.getCurrentYear()
      this.selectedMonth = this.getCurrentMonth()
      this.getTournaments()
    },
    methods: {
      getTournaments () {
        let id = this.player.general.ahlid
        let month = this.selectedMonth + 1
        let year = this.selectedYear
        let url = `general/membertournhistory/${id}/${month}/${year}`
        this.$axios({
          method: 'POST',
          url,
          data: {
            token: this.token || ''
          }
        })
          .then((res) => {
            this.tournaments = res.data
            this.loaded = true
          })
          .catch((error) => {
            console.log(error)
          })
      },
      showFilter () {
        this.dropdownFilter = !this.dropdownFilter
      },
      filterHistory () {
        let arr = []
        let games = this.player.tournamentHistory
        if (this.history === 'year') {
          for (let i = 0; i < games.length; i++) {
            if (games[i].date.search(this.getCurrentYear()) !== -1) {
              arr.push(games[i])
            }
          }
        }
        if (this.history === 'thisMonth') {
          let thisMonth = this.getCurrentMonth()
          for (let i = 0; i < games.length; i++) {
            if (games[i].date.search(this.convertMonth(thisMonth)) !== -1) {
              arr.push(games[i])
            }
          }
        } else if (this.history === 'lastMonth') {
          let lastMonth = this.getCurrentMonth() - 1
          for (let i = 0; i < games.length; i++) {
            if (games[i].date.search(this.convertMonth(lastMonth)) !== -1) {
              arr.push(games[i])
            }
          }
        }
        if (arr.length === 0) {
          return false
        }
        return arr.slice(0, 10)
      },
      switchHistory (history) {
        this.history = history
        this.filterHistory()
      },
      getCurrentMonth () {
        let date = new Date()
        return date.getMonth()
      },
      convertMonth (number) {
        // Number is month 0 - Jan, 1 - Feb, etc. If current month is Nov or Dec turn to Jun and Feb
        if (number === 12) {
          number = 0
        }
        if (number === 13) {
          number = 1
        }
        switch (number) {
          case 0:
            return 'Jan'
          case 1:
            return 'Feb'
          case 2:
            return 'Mar'
          case 3:
            return 'Apr'
          case 4:
            return 'May'
          case 5:
            return 'Jun'
          case 6:
            return 'Jul'
          case 7:
            return 'Aug'
          case 8:
            return 'Sep'
          case 9:
            return 'Oct'
          case 10:
            return 'Nov'
          case 11:
            return 'Dec'
          default:
            return 'Error'
        }
      },
      getCurrentYear () {
        let date = new Date()
        return date.getFullYear()
      },
      paginatePlus () {
        if (this.tournaments.length > (this.pagination + 10)) {
          this.pagination += 10
        }
      },
      paginateMinus () {
        if (this.pagination >= 10) {
          this.pagination -= 10
        }
      }
    }
  }
</script>
